import { render } from "./pdfdownload.vue?vue&type=template&id=9f395372"
import script from "./pdfdownload.vue?vue&type=script&lang=js"
export * from "./pdfdownload.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__